import { timeSpanToDateRange } from '../../../../util'

import { ISavedSearchFilters, ITimeSpan, IShortSafetyCaseSearchFilter } from '../../../../interfaces'
import { ISafetyCaseFilterValues, ISafetyCaseFilterUpsertValues } from './safety-case-filter-form-types'

export const objectToSafetyCaseFilterValues = (object?: {
  [key: string]: any
}): ISafetyCaseFilterUpsertValues => ({
  startedDateRange: { 0: object?.startedAtFrom || '', 1: object?.startedAtTo || '' },
  originatedFromSafetyReport: object?.originatedFromSafetyReport || 0,
  statusIds: object?.statusIds || [],
  searchTagIds: object?.searchTagIds || [],
})

export const savedSearchFilterToSavedSafetyCaseFilterValues = (
  savedSearchFilter: ISavedSearchFilters | undefined,
  dynamicOptions?: { startedAtFromTimeSpan?: ITimeSpan | null },
): ISafetyCaseFilterUpsertValues | undefined => {
  if (!savedSearchFilter) {
    return savedSearchFilter
  }

  let workOrderFilterObject
  try {
    workOrderFilterObject = JSON.parse(savedSearchFilter.filterJson)
  } catch (err) {
    workOrderFilterObject = {}
  }

  const filterValues = objectToSafetyCaseFilterValues(workOrderFilterObject)

  if (dynamicOptions?.startedAtFromTimeSpan) {
    filterValues.startedDateRange = timeSpanToDateRange(dynamicOptions.startedAtFromTimeSpan)
  }

  return filterValues
}

export const savedSafetyCaseFilterValuesToSavedSearchFilterAddUpsert = (
  savedSafetyCaseFilterValues: ISafetyCaseFilterValues | undefined,
): IShortSafetyCaseSearchFilter => ({
  startedAtBegin: savedSafetyCaseFilterValues?.startedDateRange?.[0] || '',
  startedAtEnd: savedSafetyCaseFilterValues?.startedDateRange?.[1] || '',
  originatedFromSafetyReport: savedSafetyCaseFilterValues?.originatedFromSafetyReport || 0,
  statusIds: savedSafetyCaseFilterValues?.statusIds || [],
  searchTagIds: savedSafetyCaseFilterValues?.searchTagIds || [],
})

export const savedSafetyCaseFilterValuesToSavedSearchFilterUpdateUpsert = (
  savedSafetyCaseFilterValues: ISafetyCaseFilterValues | undefined,
): IShortSafetyCaseSearchFilter =>
  savedSafetyCaseFilterValuesToSavedSearchFilterAddUpsert(savedSafetyCaseFilterValues)
